import { useContext } from 'react';
import Scrollbar from 'src/components/Scrollbar';
import { SidebarContext } from 'src/contexts/SidebarContext';

import {
  Box,
  Drawer,
  alpha,
  styled,
  Divider,
  useTheme,
  Button,
  lighten,
  darken,
  Tooltip
} from '@mui/material';

import SidebarMenu from './SidebarMenu';
import Logo from 'src/components/LogoSign';

const SidebarWrapper = styled(Box)(
  ({ theme }) => `
        width: ${theme.sidebar.width};
        min-width: ${theme.sidebar.width};
        color: ${theme.colors.alpha.trueWhite[70]};
        position: relative;
        z-index: 7;
        height: 100%;
        padding-bottom: 68px;
`
);

// function Sidebar() {
//   const { sidebarToggle, toggleSidebar } = useContext(SidebarContext);
//   const closeSidebar = () => toggleSidebar();
//   const theme = useTheme();
//   const lang = sessionStorage.getItem('appLanguage') || 'ar'

//   return (
//     <>
//       <SidebarWrapper
//         sx={{
//           display: {
//             xs: 'none',
//             lg: 'inline-block'
//           },
//           position: 'fixed',
//           left: lang === 'ar' ? 'auto' : 0,
//           right: lang === 'ar' ? 0 : 'auto',
//           top: 0,
//           background:
//             theme.palette.mode === 'dark'
//               ? alpha(lighten(theme.header.background, 0.1), 0.5)
//               : "#1F4D3A",
//           boxShadow:
//             theme.palette.mode === 'dark' ? theme.sidebar.boxShadow : 'none'
//         }}
//       >
//         <Box mt={3}>
//           <Box
//             mx={2}
//             sx={{
//               width: 52
//             }}
//           >
//             <Logo />
//           </Box>
//         </Box>
//         <Scrollbar>

//           <Divider
//             sx={{
//               mt: theme.spacing(3),
//               mx: theme.spacing(2),
//               background: theme.colors.alpha.trueWhite[10]
//             }}
//           />
//           <SidebarMenu />
//         </Scrollbar>
//         <Divider
//           sx={{
//             background: theme.colors.alpha.trueWhite[10]
//           }}
//         />
//       </SidebarWrapper>
//       <Drawer
//         sx={{
//           boxShadow: `${theme.sidebar.boxShadow}`
//         }}
//         anchor={lang === 'ar' ? 'right' : 'left'}
//         open={sidebarToggle}
//         onClose={closeSidebar}
//         variant="temporary"
//         elevation={9}
//       >
//         <SidebarWrapper
//           sx={{
//             background:
//               theme.palette.mode === 'dark'
//                 ? theme.colors.alpha.white[100]
//                 : "#1F4D3A"
//           }}
//         >
//           <Scrollbar>
//             <Box mt={3}>
//               <Box
//                 mx={2}
//                 sx={{
//                   width: 52
//                 }}
//               >
//                 <Logo />
//               </Box>
//             </Box>
//             <Divider
//               sx={{
//                 mt: theme.spacing(3),
//                 mx: theme.spacing(2),
//                 background:theme.palette.mode === 'dark'?"#fff": theme.colors.alpha.trueWhite[10]
//               }}
//             />
//             <SidebarMenu />
//           </Scrollbar>
//         </SidebarWrapper>
//       </Drawer>
//     </>
//   );
// }

// export default Sidebar;


// Sidebar.tsx
function Sidebar() {
  const { sidebarToggle, toggleSidebar } = useContext(SidebarContext);
  const closeSidebar = () => toggleSidebar();
  const theme = useTheme();
  const isRTL = theme.direction === 'rtl';

  return (
    <>
      <SidebarWrapper
        sx={{
          display: { xs: 'none', lg: 'inline-block' },
          position: 'fixed',
          left: 0, // let the RTL cache mirror this to `right: 0` when needed
          top: 0,
          background:
            theme.palette.mode === 'dark'
              ? alpha(lighten(theme.header.background, 0.1), 0.5)
              : '#1F4D3A',
          boxShadow: theme.palette.mode === 'dark' ? theme.sidebar.boxShadow : 'none'
        }}
      >
        <Box mt={3}>
          <Box mx={2} sx={{ width: 52 }}>
            <Logo />
          </Box>
        </Box>
        <Scrollbar>
          <Divider
            sx={{
              mt: theme.spacing(3),
              mx: theme.spacing(2),
              background: theme.colors.alpha.trueWhite[10]
            }}
          />
          <SidebarMenu />
        </Scrollbar>
        <Divider sx={{ background: theme.colors.alpha.trueWhite[10] }} />
      </SidebarWrapper>

      <Drawer
        sx={{ boxShadow: `${theme.sidebar.boxShadow}` }}
        anchor={isRTL ? 'right' : 'left'} // this is a Drawer PROP, not CSS — must stay manual
        open={sidebarToggle}
        onClose={closeSidebar}
        variant="temporary"
        elevation={9}
      >
        <SidebarWrapper
          sx={{
            background:
              theme.palette.mode === 'dark'
                ? theme.colors.alpha.white[100]
                : '#1F4D3A'
          }}
        >
          <Scrollbar>
            <Box mt={3}>
              <Box mx={2} sx={{ width: 52 }}>
                <Logo />
              </Box>
            </Box>
            <Divider
              sx={{
                mt: theme.spacing(3),
                mx: theme.spacing(2),
                background: theme.palette.mode === 'dark' ? '#fff' : theme.colors.alpha.trueWhite[10]
              }}
            />
            <SidebarMenu />
          </Scrollbar>
        </SidebarWrapper>
      </Drawer>
    </>
  );
}

export default Sidebar;